export const CATEGORY_LABELS = {
  politik: "Politik",
  international: "International",
  wirtschaft: "Wirtschaft",
  gesellschaft: "Gesellschaft",
  kultur: "Kultur",
  sport: "Sport",
};

export const CATEGORIES = ["politik", "international", "wirtschaft", "gesellschaft", "kultur", "sport"];

const MONTHS_DE = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli",
  "August", "September", "Oktober", "November", "Dezember"];
const DAYS_DE = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];

export function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return `${d.getDate()}. ${MONTHS_DE[d.getMonth()]} ${d.getFullYear()}`;
}

export function formatDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${formatDate(iso)}, ${hh}:${mm} Uhr`;
}

export function formatFullDate(d = new Date()) {
  return `${DAYS_DE[d.getDay()]}, ${d.getDate()}. ${MONTHS_DE[d.getMonth()]} ${d.getFullYear()}`;
}

export function monthName(m) {
  return MONTHS_DE[m - 1];
}

export function readingTime(html) {
  if (!html) return 1;
  const text = html.replace(/<[^>]+>/g, " ");
  const words = text.trim().split(/\s+/).length;
  return Math.max(1, Math.round(words / 200));
}
